function messages(value) {
  if (!Array.isArray(value)) return []
  return value.filter(Boolean).map((item) => String(item))
}

export function normalizeKonturResult(result) {
  return {
    filename: typeof result?.filename === 'string' ? result.filename : '',
    warnings: messages(result?.warnings),
    errors: messages(result?.errors),
  }
}

export function konturWarningsConfirmation(warnings) {
  return `Kontur обнаружил предупреждения:\n${warnings.map((warning) => `• ${warning}`).join('\n')}\n\nСкачать XML?`
}
